import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useGetformMutation, useYearlyleaveMutation } from "../../slices/formApiSlice";
import { parseUserInfo } from "../../utils/parseUtil";
import { useSelector } from "react-redux";

const YearlyReportScreen = () => {
  const [year, setYear] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [yearsOptions, setYearsOptions] = useState([]);

  const { userInfo } = useSelector((state) => state.auth);
  const [yearlyLeave, { isLoading }] = useYearlyleaveMutation();

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();

    const startYear = parseInt(process.env.REACT_APP_START_YEAR, 10 || 2020);

    const options = [];
    for (let i = startYear; i <= currentYear + 1; i++) {
      options.push(i);
    }

    setYearsOptions(options);
    setYear(currentYear.toString());
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const reqCompanyCode = userInfo[13]?.InfoField;
    const reqEmpCode = userInfo[1]?.InfoField;

    const formData = new FormData();
    formData.append("description", "GetStaffDetails");
    formData.append("title", "GetForm14ForEmployee");
    formData.append("ReqYear", year);
    formData.append("ReqEmpCode", reqEmpCode);
    formData.append("ReqCompanyCode", reqCompanyCode);
    formData.append("ReqRptType", "2");

    // Log formData contents
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    try {
      const res = await yearlyLeave(formData);

      const parsedData = parseUserInfo(res);

      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        const data = parsedData[0];

        if (data.ErrorCode === "0") {
          let pdfPath = data.JSONData1;

          if (pdfPath.startsWith("/api/WebServiceForStaffData.aspx/")) {
            pdfPath = pdfPath.replace("/api/WebServiceForStaffData.aspx/", "/");
          }

          const backendUrl = process.env.REACT_APP_URL;
          const pdfUrl = `${backendUrl}${pdfPath}`;

          setPdfUrl(pdfUrl);
          setShowModal(true);
        } else {
          toast.error(data.ErrorMessage || "An error occurred");
        }
      } else {
        toast.error("Failed to parse user info");
      }
    } catch (err) {
      console.error("Error submitting data:", err);
      toast.error(err?.data?.message || "Error submitting data");
    }
  };

  return (
    <Container className="form-container mt-5">
      <h4 className="mt-4 text-center">Print Yearly Leave Status</h4>
      <Form className="border p-4 rounded bg-light" onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col>
            <Form.Group controlId="year">
              <Form.Label>Year</Form.Label>
              <Form.Control as="select" value={year} onChange={(e) => setYear(e.target.value)} className="form-control-hover" required>
                {yearsOptions.map((yr) => (
                  <option key={yr} value={yr}>
                    {yr}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Col>
          <Button variant="primary" type="submit" className="mt-3 px-5">
            Print
          </Button>
        </Col>
      </Form>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          Print Yearly Leave Status
          {/* <div className='ms-auto'>
            <Button variant="success" onClick={handleSendToWhatsApp}>
              <FaWhatsapp style={{ marginRight: '8px' }} />
              Send to WhatsApp</Button>
          </div> */}
        </Modal.Header>
        <Modal.Body>{pdfUrl && <iframe src={pdfUrl} style={{ width: "100%", height: "500px" }} title="PDF Viewer" />}</Modal.Body>
      </Modal>
    </Container>
  );
};

export default YearlyReportScreen;
